import { ModelValue, nonRegularFieldName, ViewModel, ViewModelFieldName } from "../../../Core/CoreTypes";
import { ReadonlyModelValuesBatch } from "../../../Core/ModelStoring/ModelChunk";
import { ModelHunk } from "../../../Core/ModelStoring/ModelHunk";
import { IFormModelAccessor } from "../../IFormModelAccessor";

import { IHelperFunctionsModelAccessor } from "./IHelperFunctionsCallContext";

export class HelperFunctionsModelAccessor implements IHelperFunctionsModelAccessor {
    readonly #modelAccessor: IFormModelAccessor;

    public constructor(modelAccessor: IFormModelAccessor) {
        this.#modelAccessor = modelAccessor;
    }

    public fill(modelValuesBatch: ReadonlyModelValuesBatch): void {
        this.#modelAccessor.setBatch(ModelHunk.createFromValuesBatch(modelValuesBatch));
    }

    public getCached(path: string): ViewModel;
    public getCached(path: string, name: "children"): string[] | undefined;
    public getCached(path: string, name: "errorsCount" | "warningsCount"): number | undefined;
    public getCached(path: string, name: string): ModelValue;
    public getCached(path: string, name?: string): ViewModel | string[] | undefined | number | ModelValue {
        if (name == undefined) {
            return this.#modelAccessor.getViewModel(path)?.value;
        }

        return this.#modelAccessor.getViewModelField(path, nonRegularFieldName(name));
    }

    public set(path: string, name: ViewModelFieldName, value: ModelValue): void {
        this.#modelAccessor.setViewModelField(path, name, value);
    }
}
